<template>
   <el-container class="content" style="display: block;">
     <div class="" style="width: 100%;height: auto;" >
       <!-- <img src="https://images.yoooooo.com/shouye/bjn31.gif"  style="position: absolute;top: 0;left: 0;z-index: 1;" :style="{'width': screenWidth+'px','height': screenHeight+'px'}"> -->
       <video autoplay loop muted playsinline style="object-fit: contain;width: 100%;height: auto;">
         <source src="https://universe.universe.top/guanwang/yuzhou002.webm" type="video/mp4" />
       </video>
     </div>
     <div class="jianjie"  :style="{'width':screenWidth*0.7+'px','left':screenWidth*0.15+'px'}">
       宇宙之幂（深圳）科技集团有限公司简介：《宇宙之幂》，如其名，是一个在【幂之宇宙】拥有幂次级超巨量宇宙群的公司,【幂之宇宙】拥有的幂次级超巨量宇宙群中的宇宙均拥有918330048个维度。
      《宇宙之幂》基于【幂之宇宙】内不断膨胀、分裂、衍生的幂次级超巨量宇宙群，向【平行宇宙】和【现实宇宙】释放了1000+条宇宙级产品线，以及20000+个宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序、
       宇宙级硬件产品制造方式及流程，以服务全球的人类和机构，每一项都具有全球应用和全球持续营收的能力。
       <div>
         <img :src="require('@/assets/image/zhi.png')" style="width: 30px;height: 30px;object-fit: contain;"/>
         <span style="height: 40px;line-height: 40px;text-align: center;"><a href="https://universe.top/contact" style="text-decoration-line:none;color:#909090 ;">详情介绍</a></span>
      </div>
       <!-- <div style="">地址：深圳市南山区粤海街道深圳湾科技生态园12栋B座52层整层</div>
       <div>联系方式：0755-86978927</div> -->
     </div>
     <div style="position: fixed;z-index: 1005;background-color: #000;z-index: 1005;left: 0;bottom: 0;"  :style="{'width':screenHeight*0.5+'px','height':screenHeight*0.3+'px'}" >
       <video autoplay loop playsinline  width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo1" v-if="ishows">
         <source :src="index_url" type="video/mp4">

       </video>
     </div>
     <div class="daohangw" style="position: absolute;right: 50%;top: 30%;" >
       <div style="position: fixed;right: 0;top: 0;" :class="{cdaohang:cshow}" :style="{'width': screenWidth*0.23+'px','height': screenWidth*0.23+'px'}">
         <div style="position: fixed;z-index: 1005;z-index: 1005;right: 0;bottom: 0;background-color: #000000;" :style="{'width': screenWidth*0.24+'px','height': screenWidth*0.15+'px'}" v-if="ishow">
           <div style="position: absolute;z-index: 1005;z-index: 1005;right: 2%;top: 2%;background-color: #000000;color: #ffffff;" @click="closevideo()">关闭</div>
           <video width="100%" height="100%" ref="videoPlayer1"  @ended="restartVideo1" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo" v-if="ishow">
             <source :src="video_url" type="video/mp4">

           </video>
         </div>

         <div class="" style="width: 100%;height: 100%;object-fit: contain;">
           <!-- <img src="https://images.yoooooo.com/image/others/changjing/img/changjing/3/2.gif"   style="object-fit: contain;position: fixed;right: 0;bottom: 0;" :style="{'height': screenWidth*0.15+'px'}"> -->
           <video autoplay loop muted playsinline  style="object-fit: contain;height: auto;position: fixed;right: 0px;bottom: 0px;" :style="{'height': screenWidth*0.145+'px'}">
             <source src="https://universe.universe.top/guanwang/wenzi/bj.webm" type="video/mp4" />
           </video>
         </div>
         <div class="" style="object-fit: contain;z-index: 99999;">
              <!-- <img :src="require('@/assets/image/h2.gif')" @click="cshows1()" style="object-fit: contain;position: fixed;right: 9%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.105+'px','right':screenWidth*0.1+'px'}"> -->
              <video autoplay loop muted playsinline @click="cshows1()" style="object-fit: contain;width: 100%;height: auto;position: fixed;right: 9%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.105+'px','right':screenWidth*0.1+'px'}">
                <source src="https://universe.universe.top/guanwang/wenzi/f2.webm" type="video/mp4" />
              </video>
              <img src="https://images.yoooooo.com/shouye/wenzi/9.gif"  style="object-fit: contain;position: fixed;right: 9%;" :style="{'width': screenWidth*0.1+'px','bottom':screenWidth*0.142+'px','right':screenWidth*(0.1-0.08)+'px'}">
           <ul style="z-index: 99999;position: fixed;right: 0;background-color: #001524;line-height: 25px;width: 340px;text-indent: 5%;overflow-y: scroll;" v-if="cshow1" :style="{'top': 0,'height':screenHeight*0.5+'px'}">

             <li class="s_d_l" style="color: #ffffff;z-index: 99999;" v-for="(val, index) in index1" :key="index" @click="open(val['url'])">{{val['name']}}</li>
           </ul>

         </div>
         <div class="" style="object-fit: contain;z-index: 99999;" >
           <!-- <img :src="require('@/assets/image/h4.gif')" @click="cshows2()" style="object-fit: contain;position: fixed;right: 9%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.09+'px','right':screenWidth*0.19+'px'}"> -->
           <video autoplay loop muted playsinline @click="cshows2()" style="object-fit: contain;width: 100%;height: auto;position: fixed;right: 9%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.09+'px','right':screenWidth*0.19+'px'}">
             <source src="https://universe.universe.top/guanwang/wenzi/f4.webm" type="video/mp4" />
           </video>
           <img src="https://images.yoooooo.com/shouye/wenzi/8.gif"  style="object-fit: contain;position: fixed;right: 9%;" :style="{'width': screenWidth*0.1+'px','bottom':screenWidth*0.127+'px','right':screenWidth*(0.19-0.08)+'px'}">
           <ul style="z-index: 99999;position: fixed;right: 0;background-color: #001524;line-height: 25px;width: 160px;text-indent: 5%;overflow-y: scroll;" v-if="cshow2" :style="{'top': 0,'height':screenHeight*0.5+'px'}">
             <li class="s_d_l" style="color: #ffffff;z-index: 99999;" v-for="(val, index) in index2" :key="index" @click="open(val['url'])">{{val['name']}}</li>

           </ul>
         </div>
         <div class="" style="object-fit: contain;z-index: 99999;" >
           <!-- <img :src="require('@/assets/image/h3.gif')" @click="cshows3()" style="object-fit: contain;position: fixed;right: 1%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.095+'px','right':screenWidth*0.01+'px'}"> -->
           <video autoplay loop muted playsinline @click="cshows3()" style="object-fit: contain;width: 100%;height: auto;position: fixed;right: 1%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','bottom':screenWidth*0.095+'px','right':screenWidth*0.01+'px'}">
             <source src="https://universe.universe.top/guanwang/wenzi/f3.webm" type="video/mp4" />
           </video>
           <img src="https://images.yoooooo.com/shouye/wenzi/10.gif"  style="object-fit: contain;position: fixed;right: 1%;" :style="{'width': screenWidth*0.1+'px','bottom':screenWidth*0.132+'px','right':screenWidth*(0.01-0.03)+'px'}">
           <ul style="z-index: 99999;position: fixed;right: 0;background-color: #001524;line-height: 25px;width: 160px;text-indent: 5%;overflow-y: scroll;" v-if="cshow3" :style="{'top': 0,'height':screenHeight*0.5+'px'}">
              <li class="s_d_l" style="color: #ffffff;z-index: 99999;" v-for="(val, index) in index3" :key="index" @click="open(val['url'])">{{val['name']}}</li>

           </ul>
         </div>
       </div>

     </div>

    <!-- <div class="" style="width: 80%;height: 80%;object-fit: contain;">
      <img src="https://images.yoooooo.com/shouye/bj1.gif"  style="position: absolute;left: 0;top: 0;z-index: 0;" :style="{'width': screenWidth+'px','height': screenWidth+'px'}">
    </div> -->


    <div>
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img src="https://images.yoooooo.com/shouye/tou.gif" @click="goshipin()" style="object-fit: contain;position: fixed;left: 37%;top: 59%;z-index: 10;" :style="{'width': screenWidth*0.11+'px','height': screenWidth*0.11+'px','left':screenWidth*0.89/2+'px','top':screenWidth*0.32+'px'}"> -->
        <video autoplay loop muted playsinline @click="goshipin()" style="object-fit: contain;width: 100%;height: auto;position: fixed;left: 37%;top: 59%;z-index: 10;" :style="{'width': screenWidth*0.11+'px','height': screenWidth*0.11+'px','left':screenWidth*0.89/2+'px','top':screenWidth*0.32+'px'}">
          <source src="https://universe.universe.top/guanwang/tou.webm" type="video/mp4" />
        </video>

        <img src="https://images.yoooooo.com/shouye/wenzi/7.gif" @click="goshipin()"  style="object-fit: contain;position: fixed;left: 37%;top: 59%;z-index: 10;" :style="{'width': screenWidth*0.12+'px','left':screenWidth*(0.89/2+0.055)+'px','top':screenWidth*0.43+'px'}">
      </div>


      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[0]['img']" @click="goNext(1)" style="object-fit: contain;position: fixed;left: 16%;z-index: 1008;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.1+'px','left':screenWidth*0.34/2+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/hsmall/2.gif" @click="goNext(1)" style="object-fit: contain;position: fixed;left: 16%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*0.34/2+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(1)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 16%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.1+'px','left':screenWidth*0.34/2+'px'}">
          <source src="https://universe.universe.top/guanwang/1tq.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(1)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 16%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*0.34/2+'px'}">
          <source src="https://universe.universe.top/guanwang/2.webm" type="video/mp4" />
        </video>


        <img src="https://images.yoooooo.com/shouye/wenzi/1.gif" @click="goNext(1)"  style="object-fit: contain;position: fixed;left: 16%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2-0.075)+'px'}">
      </div>
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[1]['img']" @click="goNext(2)" style="object-fit: contain;position: fixed;left: 24%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.09)+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/hsmall/3.gif" @click="goNext(2)"  style="object-fit: contain;position: fixed;left: 24%;z-index: 1005;" :style="{'width': screenWidth*0.085+'px','height': screenWidth*0.085+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(2)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 16%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.09)+'px'}">
          <source src="https://universe.universe.top/guanwang/2.2.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(2)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 24%;" :style="{'width': screenWidth*0.085+'px','height': screenWidth*0.085+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08)+'px'}">
          <source src="https://universe.universe.top/guanwang/2q.webm" type="video/mp4" />
        </video>


        <img src="https://images.yoooooo.com/shouye/wenzi/2.gif" @click="goNext(2)"   style="object-fit: contain;position: fixed;left: 24%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.09-0.08)+'px'}">
      </div>
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[2]['img']" @click="goNext(3)" style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*2+0.015)+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/small/h2.gif" @click="goNext(3)"  style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*2+0.005)+'px'}"> -->

        <video autoplay loop muted playsinline @click="goNext(3)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 31.5%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*2+0.015)+'px'}">
          <source src="https://universe.universe.top/guanwang/3t.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(3)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 31.5%;" :style="{'width': screenWidth*0.085+'px','height': screenWidth*0.083+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*2+0.003)+'px'}">
          <source src="https://universe.universe.top/guanwang/3qz.webm" type="video/mp4" />
        </video>



        <img src="https://images.yoooooo.com/shouye/wenzi/3.gif" @click="goNext(3)"  style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*2+0.005-0.075)+'px'}">



      </div>
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[7]['img']" @click="goNext(8)" style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*3+0.016)+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/small/12.gif" @click="goNext(8)"  style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*3+0.006)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(8)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 32.8%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*3+0.016)+'px'}">
          <source src="https://universe.universe.top/guanwang/8t.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(8)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 32.8%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*3+0.006)+'px'}">
          <source src="https://universe.universe.top/guanwang/12.webm" type="video/mp4" />
        </video>

        <img src="https://images.yoooooo.com/shouye/wenzi/12.gif" @click="goNext(8)"  style="object-fit: contain;position: fixed;left: 32.5%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*3+0.005+0.05)+'px'}">
      </div>

      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[3]['img']" @click="goNext(4)" style="object-fit: contain;position: fixed;left: 41%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*4+0.018)+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/hsmall/6.gif" @click="goNext(4)"  style="object-fit: contain;position: fixed;left: 41%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*4+0.008)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(4)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 41%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*4+0.018)+'px'}">
          <source src="https://universe.universe.top/guanwang/4tq.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(4)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 41%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*4+0.008)+'px'}">
          <source src="https://universe.universe.top/guanwang/6.webm" type="video/mp4" />
        </video>

        <img src="https://images.yoooooo.com/shouye/wenzi/4.gif" @click="goNext(4)"  style="object-fit: contain;position: fixed;left: 41%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*4+0.048)+'px'}">
      </div>
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[6]['img']" @click="goNext(7)" style="object-fit: contain;position: fixed;left: 41%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*5+0.018)+'px'}"> -->
        <!-- <img src="https://images.yoooooo.com/shouye/hsmall/h1.gif" @click="goNext(7)"  style="object-fit: contain;position: fixed;left: 41%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*5+0.01)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(7)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 41%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*5+0.018)+'px'}">
          <source src="https://universe.universe.top/guanwang/7t.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(7)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 41%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*5+0.01)+'px'}">
          <source src="https://universe.universe.top/guanwang/6qz.webm" type="video/mp4" />
        </video>


        <img src="https://images.yoooooo.com/shouye/wenzi/11.gif" @click="goNext(7)"  style="object-fit: contain;position: fixed;left: 41%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*5+0.048)+'px'}">
      </div>

      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[4]['img']" @click="goNext(5)" style="object-fit: contain;position: fixed;left: 49%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*6+0.022)+'px'}"> -->
        <!-- <img :src="require('@/assets/image/j1.gif')" @click="goNext(5)"  style="object-fit: contain;position: fixed;left:49%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*6+0.012)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(5)" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 49%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*6+0.022)+'px'}">
          <source src="https://universe.universe.top/guanwang/5t.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(5)" style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 49%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*6+0.012)+'px'}">
          <source src="https://universe.universe.top/guanwang/k1.webm" type="video/mp4" />
        </video>

        <img src="https://images.yoooooo.com/shouye/wenzi/5.gif" @click="goNext(5)"  style="object-fit: contain;position: fixed;left:49%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*6+0.052)+'px'}">
      </div>

      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <!-- <img :src="list[5]['img']" @click="goNext(6)" style="object-fit: contain;position: fixed;left: 57%;z-index: 1008;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*7+0.022)+'px'}"> -->
        <!-- <img :src="require('@/assets/image/h1.gif')" @click="goNext(6)"  style="object-fit: contain;position: fixed;left: 57%;z-index: 1005;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*7+0.014)+'px'}"> -->
        <video autoplay loop muted playsinline @click="goNext(6)"  style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 57%;" :style="{'width': screenWidth*0.06+'px','height': screenWidth*0.06+'px','top':screenWidth*0.12+'px','left':screenWidth*(0.34/2+0.08*7+0.022)+'px'}">
          <source src="https://universe.universe.top/guanwang/6t.webm" type="video/mp4" />
        </video>
        <video autoplay loop muted playsinline @click="goNext(6)"  style="object-fit: contain;width: 100%;height: auto;z-index: 1005;position: fixed;left: 57%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.18+'px','left':screenWidth*(0.34/2+0.08*7+0.014)+'px'}">
          <source src="https://universe.universe.top/guanwang/j1.webm" type="video/mp4" />
        </video>

        <img src="https://images.yoooooo.com/shouye/wenzi/6.gif" @click="goNext(6)"   style="object-fit: contain;position: fixed;left: 57%;z-index: 1005;" :style="{'width': screenWidth*0.12+'px','top':screenWidth*0.26+'px','left':screenWidth*(0.34/2+0.08*7+0.052)+'px'}">
      </div>
    </div>


     <div class="beian">


      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


     </div>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        isOpen: false,
        bigImg:'',
        list:[],
        img1:'',
        img2:'',
        img3:'',
        img4:'',
        img5:'',
        img6:'',
        blue:'rgba(0, 0, 255, 1)',
        yellow:'rgba(255, 255, 0, 1)',
        orange:'rgba(255, 165, 0, 1)',
        red:'rgba(255, 0, 0, 1)',

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        width:(window.innerWidth*1.1-31*6.5)/30,
        height:(window.innerWidth*1.1-31*6.5)/30,
        scrollUp: 0,
        scrollDown: 0,
        wnum:30,
        shows_id:0,
        cli:false,
        clir:false,
        clio:false,
        index_url:'https://video.universepower.cn/yuzhouzhimi/universepower_hunshayuzhou_zhiyeren_jinshasha_video3.mp4',
        index1:[],
        index2:[],
        index3:[],
        video_url:'',
        ishow:false,
        ishows:false
      };
    },
    mounted() {
        // document.addEventListener('click', () => {
        //       if (this.isOpen) {
        //         this.isOpen = false;
        //       }
        //     });
        // 监听滚轮事件
        document.addEventListener('wheel', this.preventScroll, { passive: false });
      },
      beforeDestroy() {
        // 移除事件监听
        document.removeEventListener('wheel', this.preventScroll);
        document.removeEventListener('click', () => {});
      },
    created() {

      this.loadList()
      // this.startVideo()
      this.getScreen()
      console.log(this.screenWidth,'width')

    },

	methods:{
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/'

      }

    },
    showBIg(){
      alert(this.screenWidth+'*'+this.screenHeight)
      this.screenWidth = 3140
      this.height = 1000
    },
    closevideo(){
      this.ishow = false
    },
    restartVideo1() {
      this.$refs.videoPlayer1.currentTime = 0;
      this.$refs.videoPlayer1.play();
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    pause(){
      this.$refs.videoPlayer.pause();
    },
    opens(url){


      this.ishows = false
      this.index_url = ""
      setTimeout(() => {
        this.ishows = true
        this.index_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    open(url){

      this.pause()
      this.ishow = false
      this.video_url = ""
      setTimeout(() => {
        this.ishow = true
        this.video_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer1) {
            this.$refs.videoPlayer1.play();
          }
        });
      }, 200);

    },
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    goNext(id){
      this.$router.push('/shouyet?id='+id);
    },
    goshipin(){
      this.$router.push('/shop');
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    toHome(command) {
      this.$router.push('/');
    },
    startVideo() {
      var that = this

      this.interval2 = setInterval(() => {

        that.list.forEach(function(item, index) {

          if(item['num']<item['nums']){
            item['num'] = item['num']+1;
            that.$set(that.list,index,item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          }else{
            var tt = Math.floor(Math.random() * item['imgs'].length)
            item['img'] = item['imgs'][tt]
            item['num'] = 0;

            that.$set(that.list,index,item);
          }

        })

      }, 1000);

    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadGuanwangShouye1'
      })
      .then(res=>{
        this.list = res.data.data;
        this.index_url = res.data.index_url;
        this.index1 = res.data.index1;
        this.index2 = res.data.index2;
        this.index3 = res.data.index3;

        this.opens(this.index_url)
      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  .jianjie{
    position: absolute;
    /* top: 2%; */
    color: #909090;
    z-index: 9999;
    word-wrap: break-word;
    /* font-size: 1.5rem; */
    font-family:'hanyi65';
  }
  @media screen and (min-width: 1900px) {
    .jianjie{
      top: 2%;
      font-size: 1.5rem;
    }
    .s_d_l{
      font-size: 15px;
    }
  }
  @media screen and (max-width: 1900px) {
    .jianjie{
      top: 2%;
      font-size: 1rem;
    }
    .s_d_l{
      font-size: 15px;
    }
  }
  @media screen and (max-width: 1520px) {
    .jianjie{
      top: 1%;
      font-size: 0.9rem;
    }
    .s_d_l{
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1150px) {
    .jianjie{
      top: 0.2%;
      font-size: 0.8rem;
    }
    .s_d_l{
      font-size: 12px;
    }
  }
  .cdaohang{
    background-color: #000000;
  }
  ul li:hover{
    background-color: #cacaca;
  }
  .el-dropdown-menu__item{
    color: #ffffff;
    font-weight: bold;
    font-family: guanwangdaohang;
  }
  .popper__arrow{
    display: none;
  }
  .daohangclicolor{
    color: #cacaca;
  }
  .daohangnocolor{
    color: #ffffff;
  }
.daohangcli{
  height: 50px;
  border: #00b4ff 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #001d31;
}
.daohangno{
  height: 50px;
  border: #686868 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #0071e3;
}
  .daohangw{
    position: fixed;
    z-index: 99999 !important;
    left: 40%;
    top:0%;

  }
  .beian {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .overlaydis{

    display: none;
  }
  .overlay {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .el-main{
    height: 1800px;
  }
  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }
.lefts{
  margin-left: 75px;
}
.rights{
  margin-right: 75px;
}
.gradient-border {
      float: left;
      /* margin-left: 5px; */
      margin-top: -9px;
	    position: relative;
	    /* width: 76px;
	    height: 76px; */
	    background: #fff;
	    border-radius: 50%;
	    overflow: hidden;
      /* margin:20px auto; */
      /* box-shadow: -1px 0 3px yellow, 0 1px 3px blue, 1px 0 3px orange, 0 -1px 3px red; */
      background-color: black;
	  }


	.imgs{
    position: absolute;
		width: 80%;
		height: 80%;
    object-fit: contain;
		left: 10%;
		top:10%;
	}

.daohangcliz{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangnoz{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }



</style>



// WEBPACK FOOTER //
// src/components/main/shouye1.vue